<template lang="pug">
  .page.event
    .head.container
      slider-list(v-if="sliderDates"
        :slides="sliderDates"
        :activeSlide="activeSliderDate"
        @slideChange="changeDate")
    main
      transition-group(name="fade")
        .contentWrapper(v-if="!loading && event" key="1")

          .content.container.small
            h1(v-html="event.NAME")
            img.content_img(v-if="event.DETAIL_PICTURE" :src="event.DETAIL_PICTURE" :alt="event.NAME")

          .detail(v-html="event.DETAIL_TEXT")

          .container.small
            .text
              sharing(:url="sharingUrl"
                :title="event.NAME"
                :description="''")

          .bottom.container
            router-link.app-button(:to="{name: 'HomeNewyear'}" tag="div") Вернуться назад

        preloader(v-if="loading" key="2")
</template>

<script>
import SliderList from "../components/SliderList";
import Preloader from "@/components/other/Preloader";
import Sharing from "@/components/elements/Sharing";

export default {
  name: "Event",
  data: () => ({
    event: null,
    sliderDates: null,

    loading: false,
  }),
  computed: {
    sharingUrl() {
      return `${this.hostname}/newyear/sharing.php?url=${this.hostname}/newyear/${this.$route.params.id}&title=${this.event?.NAME}&image=${this.event?.DETAIL_PICTURE}&description=`
    },

    hostname() {
      return window.location.hostname === 'localhost' ? 'https://atom75.ru' : window.location.origin;
    },

    activeSliderDate() {
      return this.sliderDates.findIndex(d => d.id === this.$route.params.id);
    },
  },
  methods: {
    async fetchEventsNewyear(){
      try {
        let {data} = await this.axios.get('?ACTION=getEventsNewyear');
        this.sliderDates = data.DATA?.EVENTS?.map(e => ({name: e.DATE_FORMAT, id: e.CODE, date: e.DATE})).reverse();
      } catch (e) {
        console.log(e);
      }
    },
    fetchEvent(code) {
      this.loading = true;
      setTimeout(async () => {
        try {
          let {data} = await this.axios.get('?ACTION=getEventsNewyearDetail&CODE=' + code);
          if (data.DATA.AVAILABLE_VIEWING === 'N') {
            this.$router.push({name: 'HomeNewyear'})
            return
          }

          this.event = data.DATA;

          setTimeout(() => {
            this.loading = false;
            setTimeout(() => {
              this.initVideos();
              this.initAudios();
              this.initGalleries();
            });
          }, 200)
        } catch (e) {
          console.log(e);
        } finally {
          this.loading = false;
        }
      }, 600)
    },
    changeDate(id) {
      if (id === this.$route.params.id) return;
      this.$router.push({
        name: 'EventNewyear',
        params: {
          id: id
        }
      })
    },
    initVideos() {
      let players = document.querySelectorAll('.app_video');
      Array.prototype.forEach.call(players, (p) => {
        let videoData = JSON.parse(p.getAttribute('data-setup'));
        if (videoData && videoData.techOrder && videoData.techOrder[0] === 'youtube') {
          p.setAttribute('poster', `https://img.youtube.com/vi/${youtube_parser(videoData.sources[0].src)}/0.jpg`)
        }
        let player = videojs(p.getAttribute('id'), this.options);
      });

      function youtube_parser(url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
      }
    },
    initAudios() {
      let audios = document.querySelectorAll('.app_audio');
      Array.prototype.forEach.call(audios, audio => {
        init(audio)
      })

      function init(audio) {
        let name = audio.getAttribute('data-name');
        let src = audio.getAttribute('data-src');
        let id = audio.getAttribute('id');

        audio.innerHTML = `<div class="jp-jplayer"></div>
                                        <div class="jp-audio">
                                            <div class="jp-type-playlist">
                                                <div class="jp-gui jp-interface">
                                                    <ul class="jp-controls">
                                                        <li><label class="name">${name}</label></li>
                                                        <li><a class="jp-play" href="javascript:;" tabindex="1">play</a></li>
                                                        <li><a class="jp-pause" href="javascript:;" tabindex="1">pause</a></li>
                                                    </ul>
                                                    <div class="jp-progress">
                                                        <div class="jp-seek-bar">
                                                            <div class="jp-play-bar"></div>
                                                        </div>
                                                    </div>
                                                    <div class="jp-volume-bar">
                                                        <div class="jp-volume-bar-value"></div>
                                                    </div>
                                                    <div class="jp-time-holder">
                                                        <div class="jp-current-time"></div>
                                                    </div>
                                                    <div class="clear"></div>
                                                </div>
                                                <div class="jp-playlist">
                                                    <ul>
                                                        <li></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>`;
        let cssSelector = {
          jPlayer: '#' + id + ' .jp-jplayer',
          cssSelectorAncestor: '#' + id + ' .jp-audio'
        };
        let playlist = [
          {
            author: "TSP",
            title: "Cro Magnon Man",
            discription: "Привет, я  описание",
            mp3: src,
          },
        ];
        let options = {
          swfPath: "js",
          supplied: "oga, mp3",
          wmode: "window",
          smoothPlayBar: false,
          keyEnabled: true
        };
        let myPlaylist = new jPlayerPlaylist(cssSelector, playlist, options);
      }
    },
    initGalleries() {
      let galleries = document.querySelectorAll('.app_gallery');
      Array.prototype.forEach.call(galleries, g => {
        new Swiper(g.querySelector('.swiper-container'), {
          grabCursor: true,
          navigation: {
            prevEl: g.querySelector('.swiper-button-prev'),
            nextEl: g.querySelector('.swiper-button-next'),
          },
          pagination: {
            el: g.querySelector('.swiper-pagination'),
            type: 'bullets',
            clickable: true,
          },
        })
      })
    }
  },
  watch: {
    $route() {
      this.fetchEvent(this.$route.params.id);
    },
  },
  created() {
    this.fetchEventsNewyear();
    this.fetchEvent(this.$route.params.id);
  },
  components: {
    Preloader,
    SliderList,
    Sharing,
  }
}
</script>

<style scoped lang="scss">

.event {
  position: relative;
  min-height: 100vh;
  padding-bottom: 5rem;
  background: url(../assets/img/footer_garland.png) no-repeat center top -0.1rem / 100% auto,
  url(../assets/img/event_bg_top.png) no-repeat center top -10rem/ 100% auto,
  url(../assets/img/event_bg_bottom.png) no-repeat center bottom / 100% auto,
  linear-gradient(to bottom, #0b0f29, #223c84);
}

.preloader {
  position: absolute;
  top: 2rem;
  left: 50%;
  transform: translateX(-50%);
}

.head {
  max-width: 101rem;
  margin-bottom: 3.9rem;
  padding-top: 4.9rem;

  .sliderList {
    margin-left: 1rem;
  }
}

main {
  position: relative;

  &::v-deep {
    .container {
      position: relative;
      z-index: 1;
      max-width: 91.7rem;
    }

    .container.small {
      padding: 0 5.2rem;
    }

    .text {
      padding: 0 1.3rem;
    }

    .content {
      margin-bottom: 5rem;

      &.grey {
        background: #f0efef;
      }

      &.red {
        background: $red;
      }

      &.blue {
        background: $blue;
      }
    }

    h1 {
      margin-bottom: 3.3rem;
      font-size: to_rem(80px);
      font-weight: bold;
      color: #fff;
    }

    h2 {
      margin: 1.8rem 0;
      font-family: 'RST', Arial;
      font-size: to_rem(32px);
      line-height: 1.3;
    }

    h3 {
      margin: 2rem 0;
      font-family: 'RST', Arial;
      font-size: to_rem(25px);
      font-weight: bold;
    }

    h6 {
      margin-bottom: 1.6rem;
      font-size: 1.25rem;

      .link {
        cursor: pointer;
        transition: text-shadow .2s;

        &:hover {
          text-shadow: 0 0 1.5rem rgba(#000, 0.5);
        }
      }

      .app_btn {
        margin-left: 1.5rem;
      }
    }

    p {
      margin: 1rem 0 2rem;
      font-family: 'RST', Arial;
      font-size: to_rem(18px);
      line-height: 1.5;
    }

    a {
      position: relative;
      color: $red;

      &:before {
        content: '';
        display: block;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        height: 1px;
        background: $red;
      }
    }

    ul, ol {
      li {
        position: relative;
        margin: 0.56rem 0;
        font-family: 'RST', Arial;
        font-size: to_rem(18px);

        &:before {
          display: block;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);

        }
      }
    }

    ul {
      padding-left: 3.5rem;

      li {
        &:before {
          content: '';
          left: -0.7rem;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: $blue;

        }
      }
    }

    ol {
      padding-left: 4rem;
      counter-reset: num;

      li {
        &:before {
          content: counter(num) '.';
          counter-increment: num;
          left: -1.3rem;
          color: $blue;
        }
      }
    }

    table {
      width: 100%;
      margin: 2rem 0 3rem;
      table-layout: fixed;
      font-family: 'RST', Arial;
      font-size: to_rem(18px);

      tr {
        &:nth-of-type(1) {
          background: #f5f5f5;
        }

        td, th {
          padding: 0.95rem;
          border: 2px solid #e8e8e8;
          text-align: center;

        }
      }
    }

    img {
      max-width: 100%;
    }

    .content_img {
      width: 100%;
      border-radius: 1rem;
      box-shadow: 0 0 to_rem(16px) 0px rgba(#8ceffe, 0.3);
    }

    blockquote {
      display: flex;
      justify-content: space-between;
      margin: 0;
      padding-top: 2.2rem;

      img {
        flex-shrink: 0;
        align-self: flex-end;
        margin-right: 1rem;
      }

      & > a {
        max-width: 71%;
        padding: 1.7rem 0;
      }

      h3 {
        margin: 0 0 2.9rem;
        font-family: BebasNeueBook, Arial;
        font-size: to_rem(50px);
        line-height: 1.2;
        font-weight: 400;
      }

      small {
        display: block;
        font-family: 'RST', Arial;
        font-size: to_rem(25px);
      }
    }

    .app_video {
      width: 50rem;
      height: 26rem;
      max-width: 100%;
      margin: 0 auto;
    }

    .app_audio {
      width: 50rem;
      max-width: 100%;
      margin: 0 auto 1rem;
    }

    .app_gallery {
      margin: 3.5rem 0;

      .swiper-container {
        position: relative;
        border-radius: 1rem;

        &:before {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 2;
          background: linear-gradient(to right, rgba(#000, 0.5) 0%, transparent 15%, transparent 85%, rgba(#000, 0.5) 100%);
          pointer-events: none;
        }
      }

      .swiper-slide {
        height: 33rem;
        background: no-repeat center center / cover;
      }

      .swiper-button-prev, .swiper-button-next {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 3rem;
        height: 5.2rem;
        margin-top: 0;
        background: url(../assets/img/arrow_white_3.png) no-repeat center center / contain;
        cursor: pointer;

        &.swiper-button-prev {
          left: 0.9rem;
          transform: translateY(-50%) scale(-1, 1);
        }

        &.swiper-button-next {
          right: 0.9rem;
          transform: translateY(-50%);
        }
      }

      .swiper-pagination {
        top: calc(100% + 1.4rem);
        left: 50%;
        transform: translateX(-50%);

        &-bullet {
          width: 0.5rem;
          height: 0.5rem;
          margin: 0 0.5rem;
          background: $red;
          opacity: 1;

          &-active {
            background: #adadad;
          }
        }
      }
    }
  }
}



.sharing {
  margin-top: 1rem;
  margin-bottom: 2rem;
}

.bottom {
  display: flex;
  justify-content: center;
}

@include mobile_or_P {

  .event {
    background: url(../assets/img/footer_garland.png) no-repeat center top -0.1rem / auto 1.2rem,
    url(../assets/img/event_bg_top.png) no-repeat center top / auto 68rem,
    url(../assets/img/event_bg_bottom.png) no-repeat left 54.9% bottom -3.5rem / auto 22.4rem,
    linear-gradient(to bottom, #0b0f29, #223c84);
  }

  .head {
    margin-bottom: 4.1rem;
    padding-top: 3.4rem;
    .sliderList {
      margin: 0 auto;
    }
  }
  main {
    &::v-deep {
      .container.small {
        padding: 0 1.3rem;
      }

      .content {
        margin-bottom: 2rem;
      }

      h1, h6 {
        max-width: 22.3rem;
        margin: 0 auto;
      }

      h1 {
        margin-bottom: 2.75rem;
        font-size: 3.2rem;
        line-height: 1.05;
        text-align: center;
      }

      h2 {
        font-size: 1.7rem;
      }

      h6 {
        margin-bottom: 1.1rem;
        font-size: 0.95rem;
      }

      p {
        margin-bottom: 1.25em;
        font-size: 1.17rem;
        line-height: 1.25;
        text-align: justify;
      }

      .content_img {
        border-radius: 2rem;
      }

      blockquote {
        flex-direction: row-reverse;

        h3 {
          margin-bottom: 1.3rem;
          font-size: 1.42rem;
          line-height: 1.22;
        }

        small {
          max-width: 90%;
          font-size: 1.16rem;
          line-height: 1.2;
        }

        img {
          max-width: 12.3rem;
          margin-right: -0.6rem;
        }

        & > a {
          padding: 0.9rem 0 3.3rem;
        }
      }

      .app_gallery {
        .swiper-slide {
          height: 13rem;
        }

        .swiper-button-prev, .swiper-button-next {
          height: 4rem;
        }

      }

      .app_video {
        width: 100%;
        height: 16rem;
      }

    }
  }
  .sharing {
    margin-bottom: 5rem;
  }
}
</style>
